//-- Copyright (c) 2021 TMT Insights Group, LLC
import DataTableLayout from '@/components/_common/Layout/DataTableLayout';
import DataTableTitleBar from '@/components/_common/Layout/DataTableTitleBar';
import TaskDrawer from './TaskDrawer';
import axios from '@/_utils/axios';
import { useToast } from '@/components/_common/Toast';
import { useQuery } from '@/components/_hooks/useQuery';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { getData } from '@/redux/slices/dataTableSlice';
import useTaskDrawer from '@/components/_hooks/useTaskDrawer';
import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const Tasks = () => {
  const query = useQuery();
  const dispatch = useAppDispatch();
  const popoutOnly = query.get('popout');
  const source = query.get('source') === 'processing-exceptions' ? 'processing-exceptions' : 'tasks';
  const currentTableKey = useAppSelector(selectCurrentTableKey);
  const { error } = useToast();
  const { activeTask, isDirty, fetchTask, onDrawerClose, onActiveTaskChange, setActiveTask, setIsDirty, taskLoading } = useTaskDrawer();

  if (popoutOnly) {
    return (
      <TaskDrawer
        isDirty={isDirty}
        setIsDirty={setIsDirty}
        onRefresh={fetchTask}
        task={activeTask}
        source={source}
        onDrawerClose={onDrawerClose}
        setActiveTask={setActiveTask}
        popoutOnly
      />
    );
  }

  const onReorderRows = (taskId: number, priority: number) => {
    return axios
      .post(`/core/tasks/${taskId}/priority/`, { priority })
      .then((res) => {
        if (!res.data?.success) throw new Error();
      })
      .catch((err) => {
        error(err.response || 'There was an error reordering the tasks.');
        dispatch(getData());
      });
  };

  return (
    <DataTableLayout tableKey="tasks" activeRowId={activeTask?.id} onRowClick={(e, item) => onActiveTaskChange(item)} onReorderRows={onReorderRows}>
      <DataTableTitleBar />
      {currentTableKey === 'tasks' && <DataTableFilters />}
      <TaskDrawer
        isDirty={isDirty}
        setIsDirty={setIsDirty}
        task={activeTask}
        onDrawerClose={onDrawerClose}
        onRefresh={fetchTask}
        loading={taskLoading}
        setActiveTask={setActiveTask}
      />
    </DataTableLayout>
  );
};

export default Tasks;
